export default "/assets/markers/delivered_on.png"